import React from 'react'

// import { LazyLoadImage } from 'react-lazy-load-image-component'
import cn from 'classnames'

import VideoModal from 'components/atoms/VideoModal'
import { ReactComponent as VideoTrigger } from 'svgs/video-icon.svg'

import './index.scss'

const getPrimaryImageIndex = (images = []) => {
  let primaryIndex = 0

  if(images && images.length > 0 && images.filter(image => image.primary).length > 0){
    primaryIndex = images.map(image => image.primary ? 'primary' : '').indexOf('primary')
  }
  return primaryIndex
}

const Carousel = ({ images = [], video }) => {
  // There's no guarentee there's an imag marked as "primary"... 
  const [ state, setState ] = React.useState({
    index: getPrimaryImageIndex(images),
    showVideoModal: false,
  })

  const handleVideoTriggerClick = () => {
    const trackerCallback = () => {
      setState({
        ...state,
        showVideoModal: true,
      })
    }

    let img = new Image()
    img.onload = trackerCallback
    img.onerror = trackerCallback

    img.src = `${video}?_=${new Date().getTime()}`
  }

  const update = index => setState({
    ...state,
    index: index,
  })

  return <div className="carousel-container">
    <div className="main-image">
      <img src={images[state.index].image_url} alt={images[state.index].attribution_text || ''} />
    </div>
    {(images.length > 0 || video) && <div className="thumbs-container">
      {images.map( (image, i) => <div key={image.image_url} className={cn('thumb', {'active': state.index === i})} onClick={ () => update(i) }>
        <img src={image.image_url} alt={image.attribution_text || ''} />
      </div>)}
      {video && <div className="thumb video-trigger-container" onClick={ () => handleVideoTriggerClick() }>
        <VideoTrigger />
      </div>}
    </div>}
    {state.showVideoModal && <VideoModal src={video} closePlayer={ () => setState({ ...state, showVideoModal: false })}/>}
  </div>
}

export default Carousel
